import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { openOnboardingContentEntity } from './thunks';
import { AllowingsState } from './types';

export const name = 'allowings';

const initialState: AllowingsState = {
  openOnboardingContentEntity: {
    status: 'idle',
  },
};

export const openOnboardingContentEntityAsync = createAsyncThunk(
  name + '/openOnboardingContentEntity',
  openOnboardingContentEntity
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(openOnboardingContentEntityAsync.pending, (state) => {
        state.openOnboardingContentEntity.status = 'loading';
      })
      .addCase(openOnboardingContentEntityAsync.fulfilled, (state) => {
        state.openOnboardingContentEntity.status = 'idle';
      })
      .addCase(openOnboardingContentEntityAsync.rejected, (state) => {
        state.openOnboardingContentEntity.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
